/**
 * Clears all redux items from `localStorage`.
 * These items are stored in `persist:root` as defined in its `persistConfig`.
 *
 * Uses a dynamic import for the store to break the circular dependency:
 * clear-redux-store → store → notificationSlice → callAzureFunctions → clear-redux-store
 */

const clearReduxStore = async () => {
  const { store, persistor } = await import('../store');
  store.dispatch({ type: 'RESET_APP' });
  persistor.purge();
};

export default clearReduxStore;
